export function newPatchId(synchronizedMicroTime: number): string {
    let str = ("000000000000000" + synchronizedMicroTime.toString(16)).substr(-16, 16);
    str += ".";
    str += ("000" + Math.floor(Math.random() * 0xffff).toString(16)).substr(-4, 4);
    str += ("000" + Math.floor(Math.random() * 0xffff).toString(16)).substr(-4, 4);
    return str;
}
